import { render, staticRenderFns } from "./UpdateSvg.vue?vue&type=template&id=5cc953bf&scoped=true&"
import script from "./UpdateSvg.vue?vue&type=script&lang=js&"
export * from "./UpdateSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc953bf",
  null
  
)

export default component.exports